import { BaseLayerElementCreator } from '@3d-scene/layer/creator/base-layer-element-creator';
import { ProjectModel } from '@project/model/project.model';
import { Group, Object3D, Vector3 } from 'three';
import { InsertArticleHelper } from '@article/helper/insert-article.helper';
import { SimpleTextValueVO } from '@shared/vo/meta-element.vo';
import { RulerElement } from '../elements/ruler-element';
import { ArticleContainer } from '../../model3d/article-container';
import { ArticleUtils } from '@article/util/article-utils';
import { MountingRailHelper } from '@project/helper/mounting-rail.helper';

export class RulerLayerElementCreator extends BaseLayerElementCreator {
  public static readonly RULER_STEP: number = 100;
  public static readonly DEFAULT_POSITION_Z: number = 175;
  public static readonly ANTI_FLICKER_Y_OFFSET: number = 0.1;

  constructor(
    private mountingRailHelper: MountingRailHelper,
    projectModel: ProjectModel,
  ) {
    super(projectModel, 'ruler');
  }

  public createLayerElements(): Group {
    const elements: Object3D[] = [];
    const mountingRailContainer: ArticleContainer = this.mountingRailHelper.getMountingRailContainer();
    if (mountingRailContainer) {
      const isFreeMounting: boolean = ArticleUtils.isFreeMounting(mountingRailContainer.article);
      const positionZ: number = isFreeMounting
        ? RulerLayerElementCreator.DEFAULT_POSITION_Z
        : this.calculateMaxGlobalArticlePoint(mountingRailContainer).z;
      const insertHelper: InsertArticleHelper = this.mountingRailHelper.getInsertArticleHelper();
      const startPoint: Vector3 = new Vector3(
        insertHelper.startPoint.x,
        insertHelper.startPoint.y + RulerLayerElementCreator.ANTI_FLICKER_Y_OFFSET,
        positionZ
      );
      const endPoint: Vector3 = new Vector3(
        insertHelper.endPoint.x,
        insertHelper.endPoint.y + RulerLayerElementCreator.ANTI_FLICKER_Y_OFFSET,
        positionZ
      );
      const elementsCount: number = Math.floor(Math.abs(endPoint.x - startPoint.x) / RulerLayerElementCreator.RULER_STEP);

      for (let i = 0; i <= elementsCount; i++) {
        const position: Vector3 = startPoint.clone().add(new Vector3(-i * RulerLayerElementCreator.RULER_STEP, 0, 0));

        let textValue: SimpleTextValueVO = new SimpleTextValueVO();
        textValue.text = (i * RulerLayerElementCreator.RULER_STEP) / 10 + '';

        const element: RulerElement = new RulerElement(position, textValue);
        elements.push(element);
      }
    }
    return this.createLayerGroup(elements);
  }
}
